import { RouteNamesEnum } from "@/const/routes"
import { RouteRecordNameGeneric } from "vue-router"

export const canRedirect = (name: RouteRecordNameGeneric, ...opts: RouteNamesEnum[]) => {
  return opts?.some((routeName) => name === routeName)
}